// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2L2 2L2 22H22V2ZM4 14.5L4 4L20 4V14.5H15.0352L14.7823 15.1248C14.3365 16.2261 13.2574 17 12 17C10.7426 17 9.66348 16.2261 9.2177 15.1248L8.96479 14.5L4 14.5ZM12 5.08579L7.58579 9.5L9 10.9142L11 8.91421V14H13V8.91421L15 10.9142L16.4142 9.5L12 5.08579Z"}}]};

const OutboxFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'outbox-filled',
    ref,
    icon: element,
  },
));

OutboxFilledIcon.displayName = 'OutboxFilledIcon';

export default OutboxFilledIcon;
